import clsx from 'clsx';
import {ChoiceProps} from '@/hooks/types';
import {RadioGroup, RadioGroupItem} from '@/shadcn_components/ui/radio-group';

export type RadioListProps = Omit<Partial<React.ComponentProps<'input'>>, 'value' | 'onChange'> & {
  //   containerClassName?: string;
  optionClassName?: string;
  choices: ChoiceProps[];
  optionValue?: string;
  optionText?: string;
  // radioProps?: Partial<Omit<RadioProps, 'ref'>>;
  value?: string;
  onChange: (value?: string | number) => void;
};

const RadioList = (props: RadioListProps) => {
  const {
    optionClassName,
    choices,
    className,
    name,
    optionValue = 'id',
    optionText = 'label',
    // radioProps,
    value,
    onChange,
  } = props;
  //   const translate = useTranslate();

  return (
    <RadioGroup className={clsx('flex flex-row h-9 w-full', className)} value={value} onValueChange={onChange}>
      {choices.map((c, i) => (
        <div key={i} className="flex flex-row items-center hover:cursor-pointer">
          <RadioGroupItem
            className="hover:cursor-pointer"
            value={c[optionValue]}
            id={name + '_' + c[optionValue]}
          />
          <label className="pl-2 hover:cursor-pointer" htmlFor={name + '_' + c[optionValue]}>
            {c[optionText]}
          </label>
        </div>
      ))}
    </RadioGroup>
  );
};

export default RadioList;
